// WARNING: These constants must be manually synced with the backend.
// When adding/removing/changing codes (BackOfficeRoleCodes included), update both:
//   - This file (frontend)
//   - src/BLogic.Moone.Domain/App/Models/AccessRoleCodes.cs (backend)
export const AccessRoleCodes = {
  Admin: "Admin",
  Customer: "Customer",
  Employee: "Employee",
  Merchant: "Merchant",
  Hunter: "Hunter",
  Aml: "Aml",
  HunterPlus: "HunterPlus",
  CustomerOnboarding: "CustomerOnboarding",
  AdminLite: "AdminLite",
  Disponent: "Disponent",
  Child: "Child",
} as const;

export type AccessRoleCode =
  (typeof AccessRoleCodes)[keyof typeof AccessRoleCodes];

export const isAccessRoleCode = (
  value: string | null | undefined,
): value is AccessRoleCode =>
  typeof value === "string" && Object.keys(AccessRoleCodes).includes(value);

// Internal mo.one roles. A back-office account is its own Identity with exactly this one context —
// it never gets "Add role", the Customer onboarding, or the link-to-customer migration flow.
export const BackOfficeRoleCodes: ReadonlyArray<AccessRoleCode> = [
  AccessRoleCodes.Admin,
  AccessRoleCodes.Aml,
  AccessRoleCodes.CustomerOnboarding,
  AccessRoleCodes.AdminLite,
];

export const isBackOfficeRole = (value: string | null | undefined): boolean =>
  isAccessRoleCode(value) && BackOfficeRoleCodes.includes(value);

// Every role a customer-side (personal) account can act as — the complement of BackOfficeRoleCodes.
export const PersonalRoleCodes: ReadonlyArray<AccessRoleCode> = Object.values(
  AccessRoleCodes,
).filter((code) => !BackOfficeRoleCodes.includes(code));
